import e from "cors";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import MainComponent from "./MainComponent";
import AtmEcom from "./AtmEcom";
import MobileBanking from "./MobileBanking";
import Itouch from "./Itouch";
import { useNavigate } from "react-router-dom";

const Form = () => {
  const navigate= useNavigate()
  const [selectedField, setSelectedField] = useState("");
  const [checkboxStates, setCheckboxStates] = useState({
    unauthorized: false,
    paidByOther: false,
    unsuccessful: false,
    differentAmount: false,
    duplicate: false,
    other: false,
  });
  const [agreementChecked, setAgreementChecked] = useState(false);
  const [showAgreementError, setShowAgreementError] = useState(false);

  useEffect(() => {
    const forms = document.querySelectorAll(".needs-validation");

    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          event.preventDefault();
          event.stopPropagation();

          const anyChecked = Object.values(checkboxStates).some(
            (value) => value === true
          );

          if (!anyChecked) {
            setShowError(true);
          } else {
            setShowError(false);
          }

          // Check if agreement checkbox is checked
          if (!agreementChecked) {
            setShowAgreementError(true);
          } else {
            setShowAgreementError(false);
          }

          if (!anyChecked || !agreementChecked || !form.checkValidity()) {
            form.classList.add("was-validated");
            return;
          }

          form.classList.add("was-validated");

          // Add your form submission logic here
          console.log("Form is valid, submitting...");
        },
        false
      );
    });
  }, [checkboxStates, agreementChecked]);

  const [specificMessage, setSpecificMessage] = useState(false);
  const [message, setMessage] = useState();

  const [showError, setShowError] = useState(false);

  // Function to handle checkbox changes
  const handleCheckboxChange = (checkboxName) => {
    const newStates = {
      ...checkboxStates,
      [checkboxName]: !checkboxStates[checkboxName],
    };
    setCheckboxStates(newStates);

    // Check if at least one checkbox is checked
    const anyChecked = Object.values(newStates).some((value) => value === true);
    setShowError(!anyChecked);
  };

  return (
    <div className="col-lg-8 bg-white rounded p-5">
      <form className="needs-validation" noValidate>
        <div className="mb-2">
          <h3 className="mb-4 text-center fw-bold">Dispute Claim</h3>
          {selectedField === "Atm" ? (
            <AtmEcom setSelectedField={setSelectedField} />
          ) : selectedField === "MobileBanking" ? (
            <MobileBanking setSelectedField={setSelectedField} />
          ) : selectedField === "iTouch" ? (
            <Itouch setSelectedField={setSelectedField} />
          ) : (
            <MainComponent setSelectedField={setSelectedField} />
          )}
        </div>

        <p className="text-black fw-bold">
          Please tick on below dispute options as appropriate:
        </p>
        <Row className="mb-2">
          <Col>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="invalidCheck1"
                checked={checkboxStates.unauthorized}
                onChange={() => handleCheckboxChange("unauthorized")}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck1"
              >
                Unauthorized transaction - I did not authorize or participate in
                the transaction(s) mentioned above or authorized anyone to
                engage in the transaction(s). At the time of this transaction
                the card was in my possession.
              </label>
            </div>
          </Col>

          <Col lg={12}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="invalidCheck2"
                checked={checkboxStates.paidByOther}
                onChange={() => handleCheckboxChange("paidByOther")}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck2"
              >
                I had paid by other means or purchase was cancelled.
              </label>
            </div>
          </Col>

          <Col lg={12}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="invalidCheck3"
                checked={checkboxStates.unsuccessful}
                onChange={() => handleCheckboxChange("unsuccessful")}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck3"
              >
                I used my Debit/ Credit card to perform transaction. However,
                the transaction was unsuccessful/declined & my account was
                debited.
              </label>
            </div>
          </Col>

          <Col lg={12}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="invalidCheck4"
                checked={checkboxStates.differentAmount}
                onChange={() => handleCheckboxChange("differentAmount")}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck4"
              >
                The amount billed by Merchant was different from Sales draft or
                documents that I have authorized.
              </label>
            </div>
          </Col>

          <Col lg={12}> 
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="invalidCheck5"
                checked={checkboxStates.duplicate}
                onChange={() => handleCheckboxChange("duplicate")}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck5"
              >
                Mentioned transaction was charged to my account more than once.
              </label>
            </div>
          </Col>

          <Col>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="invalidCheck6"
                checked={checkboxStates.other}
                onChange={() => {
                  handleCheckboxChange("other");
                  setSpecificMessage((prev) => !prev);
                }}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck6"
              >
                Any other information (please specify)
              </label>
              {showError && (
                <div className="text-danger mt-1">
                  Please select at least one option
                </div>
              )}
            </div>
          </Col>
        </Row>

        {specificMessage && (
          <Row className="mb-2">
            <Col>
              <textarea
                name="rounded w-100 form-control"
                id=""
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                className="form-control"
                required
                defaultValue=""
              />
            </Col>
          </Row>
        )}

        <p className="text-black fw-bold">Declaration</p>

        <Row className="mb-2">
          <Col>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="agreementCheck"
                checked={agreementChecked}
                onChange={(e) => {
                  setAgreementChecked(e.target.checked);
                  if (e.target.checked) {
                    setShowAgreementError(false);
                  }
                }}
              />
              <label
                className="form-check-label text-black"
                htmlFor="invalidCheck5"
              >
                I hereby declare that the above facts are true. It is understood
                that in case of any error, the bank shall be within its right to
                rectify the error unilaterally without notice to me/us and
                recover any amount wrongly paid/credited along with other
                transaction and fees. Further, I authorize the bank to debit my
                account by the reversed amount if the transaction is found
                successful and the acquirer/merchant makes a presentment/claim
                for the transaction(s).
              </label>
              {showAgreementError && (
                <div className="text-danger mt-1">Should accept agreement</div>
              )}
            </div>
          </Col>
        </Row>

        <div className="col-12">
          <button className="btn btn-primary" type="submit" onClick={()=>navigate("/dispute-claim")}>
            Submit form
          </button>
        </div>
      </form>
    </div>
  );
};

export default Form;
